// material-ui
import { ChipProps } from '@mui/material';
import { ReactNode } from 'react';
import type { BetaPageId } from '~/beta/betaPages';
import { RolePolicy } from '~/utils/roles';

import { GenericCardProps } from './root';

export enum NavActionType {
  FUNCTION = 'function',
  LINK = 'link',
}

// ==============================|| MENU TYPES ||============================== //

export type NavActionProps = {
  type: NavActionType;
  label: string;
  function?: any;
  url?: string;
  target?: boolean;
  icon: GenericCardProps['iconPrimary'] | string;
};

export type NavItemType = {
  breadcrumbs?: boolean;
  caption?: ReactNode | string;
  children?: NavItemType[];
  elements?: NavItemType[];
  chip?: ChipProps;
  /** Optional right-aligned badge (e.g. "New" brand badge). Rendered when drawer is open. */
  badge?: ReactNode;
  color?: 'primary' | 'secondary' | 'default' | undefined;
  disabled?: boolean;
  external?: boolean;
  isDropdown?: boolean;
  icon?: GenericCardProps['iconPrimary'] | string;
  id?: string;
  search?: string;
  target?: boolean;
  title?: ReactNode | string;
  type?: string;
  url?: string | undefined;
  actions?: NavActionProps[];
  policies?: RolePolicy[];
  beta?: { kind: 'opt-in'; page: BetaPageId } | { kind: 'preview' };
  activeUrls?: string[];
};

export type LinkTarget = '_blank' | '_self' | '_parent' | '_top';

export type MenuProps = {
  openedItem: string;
  openedComponent: string;
  openedHorizontalItem: string | null;

  /**
   * Indicate if dashboard layout menu open or not
   */
  isDashboardDrawerOpened: boolean;

  /**
   * Indicate if component layout menu open or not
   */
  isComponentDrawerOpened: boolean;
};
